import React from 'react';
import { createPortal } from 'react-dom';
import { useToast } from './ToastContext';
import { Toast } from './Toast';

export const ToastContainer: React.FC = () => {
  const { toasts, hideToast } = useToast();

  if (toasts.length === 0) return null;

  return createPortal(
    <div className="pointer-events-none fixed inset-0 z-50 flex flex-col items-end justify-start gap-4 p-4 sm:p-6">
      {toasts.map((toast) => (
        <Toast key={toast.id} toast={toast} onClose={hideToast} />
      ))}
    </div>,
    document.body
  );
};
